import React from 'react';
import ProgressIndicator, { ProgressStep } from '@ingka/progress-indicator';
import { styled } from 'styled-components';
import { useStateSelector } from '../store/';
import { useTranslation } from 'react-i18next';
import { getActiveStep, getTotalSteps } from '../helpers/progressHelper';
import type { OperationPage } from '../types/app';

const StyledProgressIndicator = styled(ProgressIndicator)`
  &&& {
    padding: 1rem 0;
    margin: 0 auto;
    width: 10rem;
  }
`;

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

type ProgressProps = {
  page: OperationPage;
};

const getSteps = (totalSteps: number) =>
  Array.from(Array(totalSteps).keys()).map((count) => count + 1);

const Progress: React.FC<ProgressProps> = ({ page }) => {
  const { t } = useTranslation();
  const disabledPrevButton = useStateSelector(
    (state) => state.app.disabledPrevButton,
  );

  const activeStep = getActiveStep(disabledPrevButton, page);
  const numberOfSteps = getTotalSteps(disabledPrevButton);

  return (
    <StyledProgressIndicator
      completedLabel={t('components.appHeader.stepCompleted')}
      current={activeStep - 1}
      incompleteLabel={t('components.appHeader.stepIncomplete')}
      size="small"
      type="label"
    >
      {getSteps(numberOfSteps).map((step) => (
        <ProgressStep
          key={step}
          label={
            <VisuallyHidden>
              {`${t('components.appHeader.stepsProgress', {
                activeStep: step,
                numberOfSteps,
              })}${step === activeStep ? `, ${t('components.appHeader.stepCurrent')}` : ''}`}
            </VisuallyHidden>
          }
        />
      ))}
    </StyledProgressIndicator>
  );
};

export default Progress;
